import { fromJS } from 'immutable'

export default fromJS({
  questions: {
    noAlt: '此图像缺少替代文本',
    noAnswers: '没有答案选项，请点击下一步以继续。',
    placeholder: '请注明……',
    pleaseSelect: '请选择……',
    rotateLandscape: '请关闭手机上的方向锁定并旋转到横屏以继续。',
    rotatePortrait: '请将手机从横向旋转到纵向继续。',
    ir: {
      selectWebCam: '选择网络摄像头（如有），或单击“浏览”，从您的设备上传',
      noWebCam: '未检测到网络摄像头',
      accessCamUpload: '访问摄像头/上传',
      browse: '浏览',
      uploadPhoto: '上传一张照片',
      instead: '取而代之',
      capture: '截取',
      somethingWrong: '对不起，出了一些问题。请稍后再试',
      couldntRead: '对不起，我们无法阅读代码！',
      couldntProcess: '对不起，我们无法处理您的图片！',
      moveOn: '请重试，或提交照片然后继续',
      tryAgain: '请重试',
      dataReceived: '收到数据！',
      enterManually: '请重试或在下面手动输入数据',
      positionQR: '请将QR码放在相机前面，使其处于红框里，或从电脑上传。',
      analyzing: '正在分析图片，请稍候',
      submit: '提交',
      startOver: '重新开始',
      allDone: '全部完成！',
      cantAnalyze: '注意-我们无法渲染此图像。请尝试重新提交或选择更通用的图像格式（JPG，PNG，GIF，BMP）',
      wrongFormat: '很抱歉-我们不支持此文件格式。请上传受支持的图片类型（JPG，PNG，GIF，BMP，TIF，PDF，SVG）'
    },
    vr: {
      noWebCam: '未检测到网络摄像头',
      uploadVideo: '上载影片',
      skip: '跳过？',
      accessCamUpload: '访问摄像头/上传',
      browse: '浏览',
      instead: '取而代之',
      or: '或',
      stopRecording: '停止录制',
      willBeStopped: '录制会在5分钟后停止',
      stopOnDone: '当您完成时就停止录制吧！',
      record: '录音',
      somethingWrong: '对不起，出了一些问题。请稍后再试',
      microphone: '麦克风',
      camera: '网络摄像头',
      selectMicrophone: '选择您的麦克风',
      selectCam: '选择您的网络摄像头',
      upload: '上传',
      playback: '回放',
      stopPlayback: '停止播放',
      submit: '提交',
      startOver: '重新开始',
      allDone: '全部完成！',
      alternativeRecordSpan: '请从电脑设备上传视频<br/>',
      alrenativeRecordHref: '或者您能用摄像头录制视频。',
      cantAnalyze: '注意-我们无法渲染此视频。请尝试重新提交或选择更通用的视频格式（MP4，M4V，WEBPM）',
      wrongFormat: '很抱歉-我们不支持此文件格式。请上传受支持的视频类型（MP4，AVI，M4V，WEBPM，MOV，MKV，MPG，WMV）'
    },
    cjc: {
      choose: '选择',
      pleaseChoose: '请选择',
      this: '这个',
      one: '一',
      myChoice: '我的选择'
    },
    hm: {
      addComment: '请在下面添加评论',
      commentMandatoryPlaceHolder: '请添加强制性评论... ',
      commentOptionalPlaceHolder: '请添加可选评论... ',
      dragPin: '拖动以重新定位（长按/长触以精确定位）。 ',
      removePin: '拖到图片外侧以删除。 ',
      editComment: '点击/轻触指针，以编辑评论。 ',
      addPin: '请从以下面板拖动指针，将其置于您在图片中选择的点。',
      addPins: '请从以下面板拖动指针，将其置于您在图片中选择的点。 ',
      leavePins: (minPoints, maxPoints) => `每种指针请留下至少${minPoints}个但不超过${maxPoints}个。`,
      leavePinsPerPage: (minPoints, maxPoints) => `请留下至少${minPoints}个但不超过${maxPoints}个指针。`,
      leavePinsWithOff: maxPoints => `每种指针请最多留下${maxPoints}个，或点击下一步跳过。`,
      leavePinsPerPageWithOff: maxPoints => `请最多留下${maxPoints}个指针，或点击下一步跳过。`,
      leavePinWithOff: '每种指针请最多留下1个，或点击下一步跳过。',
      leavePinPerPageWithOff: '请最多留下{max}个指针，或点击下一步跳过。',
      leaveExactlyPin: '每种指针请留下1个。',
      leaveExactlyPinPerPage: '请留下1个指针。',
      leaveExactlyPins: maxPoints => `每种指针请留下${maxPoints}个。`,
      leaveExactlyPinsPerPage: maxPoints => `请留下${maxPoints}个指针。 `,
      leaveComment: '在图片下方键入，以留下评论。',
      noAnswers: '没有答案选项，请点击下一步继续。',
      outOfPins: '您的指针已用完',
      pinsBehavior: '当您在图像上移动时，您会看到用一根探针标记的区域。',
      clusters: '您只能在这些标记的区域中放置探针。',
      contentAware: '您可以在标记区域内或外放置探针。'
    },
    mp: {
      expand_note: '请将鼠标悬停在图片上或点击图片以将其展开',
      rb_note: _rows => '请在下面的每项中仅选择1个答案:',
      cb_note: (min, max, _rows) => {
        if (1 === min && 5000 === max) {
          return '勾选所有适合项:'
        } else if (min === max) {
          return `请针对以下每项 ${min !== 1 ? '任意' : '仅选'} ${min}个回复:`
        } else if (min > 0 && max < 5000) {
          return `请针对以下每项选择至少 ${min} 个回复不超过 ${max} 个:`
        } else if (5000 === max && min > 0) {
          return `请针对以下每项选择至少 ${min} 个回复:`
        } else if (0 === min && max < 5000) {
          return `请针对以下每项选择不超过 ${max} 个回复：:`
        } else {
          return '勾选所有适合项:'
        }
      }
    },
    sh: {
      note: '如果您想在商店中购买产品，请点击产品放大并添加到您的虚拟购物车中',
      amazonNote: '点击产品，将其放大，并添加到您的虚拟购物车中',
      fullCart: '您的购物车已满！',
      qty: '数量',
      addToCart: '添加到购物车',
      deleteFromCart: '删除',
      emptyCard: '您的购物车是空的',
      total: '购物车',
      each: '項目',
      items: '每個',
      clearCart: '清除购物车',
      backToStore: '返回商店',
      na: '以上皆否',
      next: '前进',
      maxCartCountError: max => `请在您的购物车中添加不超过${max}种产品`,
      scrollError: `请左右滚动以继续进行调查。 `,
      maxSpentError: max => `请花费不超过${max}。 `,
      maxProductCountError: max => `在购物车中添加每种产品的数量请不要超过${max}。`
    },
    rb: {
      note: '请选择 只能 1 项目:'
    },
    vo: {
      note: '请完整观看视频'
    },
    cb: {
      note: (min, max) => {
        if (min === max) {
          return `请选择${min !== 1 ? '任意' : '只能'} ${min}项目:`
        } else if (min > 0 && max < 5000) {
          return `请选择至少 ${min} 项目 但是不超过 ${max}:`
        } else if (5000 === max && min > 0) {
          return `请选择至少 ${min}项目:`
        } else if (0 === min && max < 5000) {
          return `请选择不超过 ${max}项目:`
        } else {
          return '勾选所有适合项:'
        }
      }
    },
    oe: {
      na: '不适用',
      note: (min, max, optional) => {
        if (min === max) {
          return `请输入${1 !== min ? '任意' : '精确'} ${min} 字符${optional ? ' (可选)' : ''}:`
        } else if (min > 0 && max < 5000) {
          return `请输入至少 ${min} 字符${optional ? ' (可选)' : ''}:`
        } else if (5000 === max && min > 0) {
          return `请输入至少 ${min} 字符${optional ? ' (可选)' : ''}:`
        } else if (0 === min && max < 5000) {
          return `请输入不超过 ${max} 字符${optional ? ' (可选)' : ''}:`
        } else {
          return ''
        }
      }
    },
    oex: {
      note: '请填写以下字段：'
    },
    mx: {
      note: '请移动突出显示的滑块以继续',
      dragSlider: '向左或向右拖拉并回答'
    },
    psc: {
      dragLeftRight: '向左或向右拖拉并回答'
    },
    ps: {
      note: value => `请在以下项目中分配剩余的 ${value}`,
      allDone: '全部完成！',
      total: `总：`,
      dragSlider: '向左或向右拖拉并回答'
    },
    cx: {
      note: '自动滚屏开始回答问题或者手动选择'
    },
    ro: {
      note: '向上或向下拖拉并重新排序：'
    },
    md: {
      note1: '请点击/轻触您首先选择的项目 再次点击/轻触以清除选择。',
      note2: '现在，请点击/轻触您最后选择的项目 再次点击/轻触以清除选择。',
      note3: '谢谢！继续下一个问题，或点击/轻触任何未选择的项目以重新开始。'
    },
    aro: {
      note: '请在以下每组中选择一项。:'
    },
    wd: {
      note: '请确认每项最终值高于先前的值。'
    },
    emd: {
      note: '请完整观看视频',
      noAnswers: '没有答案选项，请点击下一步以继续。',
      start: '点击并按住开始',
      resume: '点击并按住以继续',
      continue: '您准备好了！<br /> 单击下一步继续',
      continueMobile: '一切已就绪！<br /> 点击此处，以继续',
      training: {
        session: '培训课程',
        note: '请完成培训',
        moveLeft: '请将拨盘一直拉到最左边',
        moveBottom: '请将拨盘一直拉到底部',
        moveRight: '现在，请将拨盘一直拉到右侧',
        moveTop: '现在，请将拨盘一直拉到顶部',
        success: '做得好'
      }
    },
    sft: {
      noAnswers: '没有答案选项，请点击下一步以继续。',
      note: '请以直观的感觉尽快回答',
      finish: '大功告成！<br /> 请单击下一步继续',
      training: {
        start:
          '<p>这个问题会快速向您显示不同的单词，并且需要您专心。 ' +
          '您需要迅速做出反应回答 </p> <p>准备开始练习了吗？</p>',
        step1: (touch, mouse, key) =>
          touch
            ? `点按 "{buttonLeft}"`
            : (mouse ? `点击 "{buttonLeft}"` : '') +
              (key && mouse ? ' / ' : '') +
              (key ? `按下 "{keyBtnLeft}" 键` : ''),
        step2: (touch, mouse, key) =>
          touch
            ? `点按 "{buttonRight}"`
            : (mouse ? `点击 "{buttonRight}"` : '') +
              (key && mouse ? ' / ' : '') +
              (key ? `按下 "{keyBtnRight}" 键` : ''),
        fail: () => '太慢了',
        success: () => '太棒了！',
        finish: () =>
          '<p><strong> 优秀！</strong></p><p>请确保您不会在接下来的2-3分钟内分心</p><p>准备好后，单击“下一步”开始</p>'
      },
      buttons: {
        start: '开始',
        yesno: {
          left: '是',
          right: '否'
        },
        matches: {
          left: '匹配',
          right: '不匹配'
        },
        fits: {
          left: '合适',
          right: '不合适'
        },
        thumbs: {
          left: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsUp"></i>',
          right: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsDown"></i>'
        }
      }
    }
  }
})
